<template>
  <div>
    <Layout></Layout>
  </div>
</template>

<script>
  export default {
    components: {
      Layout: () => import('./components/simulator/Layout.vue'),
    },
    mounted() {
      this.$router.replace(window.innerWidth < 1024 ? '/simulator/phone' : '/simulator/rules');
    },
  };
</script>
